module.exports = __webpack_public_path__ + "static/media/2-1-1_Vanish_Glossy.d50a8b60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Printing-Techniques/2-1-1_Vanish_Glossy.jpg
// module id = 1717
// module chunks = 0